// Angular
import { NgModule } from '@angular/core';
import { type Routes, RouterModule } from '@angular/router';
// Components
import { ErrorsComponent } from './errors.component';

const routes: Routes = [
  {path: '', component: ErrorsComponent}
];

@NgModule({
  imports: [
    // Angular
    RouterModule.forChild(routes),
  ],
  exports: [
    // Angular
    RouterModule,
  ]
})
export class ErrorsRoutingModule {
}
